// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8 7C8 4.79086 9.79086 3 12 3C13.6387 3 15.0494 3.98556 15.6676 5.40037C15.7243 5.53006 15.7742 5.66329 15.817 5.79965L16.1167 6.7537L18.0248 6.1544L17.7251 5.20035C17.6607 4.99511 17.5855 4.79465 17.5003 4.59963C16.5754 2.48263 14.4619 1 12 1C8.68629 1 6 3.68629 6 7V10H3.5V22H20.5V10H8V7ZM15 15V17H9V15H15Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-lock-off-filled')
export default class LockOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lock-off-filled',
    }
  }
}
